import React from 'react';
import MicroservicesCreator from './MicroservicesCreator';

export default MicroservicesCreator; 